(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boyogo-purchase-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('boyogo-order-guidance')) {
    customElements.define('boyogo-order-guidance', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const panel = this.querySelector('details.boyogo-order-guidance');
        if (!panel) return;
        this.initialized = true;
        panel.open = window.matchMedia('(min-width: 750px)').matches;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
